import useLanguage from "../i18n/useLanguage";
export default function About() {
  const { t } = useLanguage();
  return (
    <section
      id="about"
      className="min-h-screen flex items-center justify-center bg-black text-white"
    >
      <div className="flex flex-col items-center text-center px-4">
        {/* Logo */}
        <img
          src="/images/logo/logo.webp"
          alt={t("Logo Titik Senyap Studio - Studio kreatif dan pengembangan digital")}
          className="h-40 w-auto mb-10"
        />

        {/* Title */}
        <h2 className="text-4xl md:text-5xl font-bold tracking-wide mb-6">{t("Who we are?")}{" "}</h2>

        {/* Description */}
        <p className="max-w-2xl text-base md:text-lg font-normal text-gray-300 leading-relaxed">{t("Didirikan pada tahun 2026 di Indonesia, Titik Senyap Studio memulai perjalanannya sebagai studio pengembang game Roblox. Seiring berkembangnya tim, cakupan kami meluas tidak hanya pada pengembangan game, tetapi juga ke ranah pengembangan dan desain secara keseluruhan. Sebagai tim indie, kami percaya bahwa teknologi dan tools modern memungkinkan tim kecil untuk menciptakan karya digital yang dirancang dengan baik dan bermakna.")}{" "}</p>
      </div>
    </section>
  );
}
